import { ReactNode } from 'react';

export const resolveTkv2ReferenceDrawerMode = ({
  selectedDataSheet,
  drawerContent,
}: {
  selectedDataSheet: string | null;
  drawerContent?: ReactNode;
}): 'help' | 'custom' | 'module' => {
  if (selectedDataSheet === 'help-drawer') return 'help';
  if (selectedDataSheet === 'mls-map' && drawerContent != null) return 'custom';
  return 'module';
};
